export default __webpack_public_path__ + "static/media/error404_dark.d8f52dba.svg";